export const teaseCard = {
  type: 'paidContentCard',
};

export const teaseList = {
  type: 'paidContentList',
};

export default {
  teaseCard,
  teaseList,
};
